import { render, staticRenderFns } from "./Faq.vue?vue&type=template&id=36ee41e2&scoped=true"
import script from "./Faq.vue?vue&type=script&lang=js"
export * from "./Faq.vue?vue&type=script&lang=js"
import style0 from "./Faq.vue?vue&type=style&index=0&id=36ee41e2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ee41e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36ee41e2')) {
      api.createRecord('36ee41e2', component.options)
    } else {
      api.reload('36ee41e2', component.options)
    }
    module.hot.accept("./Faq.vue?vue&type=template&id=36ee41e2&scoped=true", function () {
      api.rerender('36ee41e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/Faq.vue"
export default component.exports